import { z } from 'zod';
import { HateoasTargetSchema } from './actions';

export const MemoryRegistrySchema = z.record(z.string(), z.record(z.string(), z.unknown()));
export type MemoryRegistry = z.infer<typeof MemoryRegistrySchema>;

export const ToolsRegistrySchema = z.record(z.string(), z.record(z.string(), HateoasTargetSchema));
export type ToolsRegistry = z.infer<typeof ToolsRegistrySchema>;